import React, { useEffect } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
export function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-screen" data-id="element-271">
      {/* Contact Hero */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-272">
        <div className="absolute inset-0 z-0" data-id="element-273">
          <img src="https://images.unsplash.com/photo-1596683720379-b11030608876?q=80&w=2070&auto=format&fit=crop" alt="Capsin Contact" className="w-full h-full object-cover" data-id="element-274" />
          <div className="absolute inset-0 bg-brand-cream/80 backdrop-blur-sm" data-id="element-275"></div>
        </div>
        <div className="relative z-10 text-center" data-id="element-276">
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-brand-dark mb-4" data-id="element-277">
            Contact
          </h1>
          <p className="text-brand-gray text-lg max-w-xl mx-auto px-6" data-id="element-278">
            Heb je een vraag over onze producten of wil je samenwerken? Neem
            gerust contact met ons op.
          </p>
        </div>
      </section>

      <section className="py-24 bg-white" data-id="element-279">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-280">
          <div className="flex flex-col lg:flex-row gap-16" data-id="element-281">
            {/* Contact Info */}
            <div className="w-full lg:w-1/3" data-id="element-282">
              <div className="mb-12" data-id="element-283">
                <h2 className="text-3xl font-serif font-bold text-brand-dark mb-6" data-id="element-284">
                  Contactgegevens
                </h2>
                <div className="w-12 h-1 bg-brand-red mb-8" data-id="element-285"></div>

                <ul className="space-y-6" data-id="element-286">
                  <li className="flex items-start gap-4" data-id="element-287">
                    <div className="w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center flex-shrink-0" data-id="element-288">
                      <Mail className="w-5 h-5 text-brand-red" data-id="element-289" />
                    </div>
                    <div data-id="element-290">
                      <p className="font-bold text-brand-dark" data-id="element-291">E-mail</p>
                      <a href="mailto:info@capsin.nl" className="text-brand-gray hover:text-brand-red transition-colors" data-id="element-292">
                        info@capsin.nl
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-293">
                    <div className="w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center flex-shrink-0" data-id="element-294">
                      <Phone className="w-5 h-5 text-brand-red" data-id="element-295" />
                    </div>
                    <div data-id="element-296">
                      <p className="font-bold text-brand-dark" data-id="element-297">Telefoon</p>
                      <a href="tel:0615123933" className="text-brand-gray hover:text-brand-red transition-colors" data-id="element-298">
                        06 15 12 39 33
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-4" data-id="element-299">
                    <div className="w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center flex-shrink-0" data-id="element-300">
                      <MapPin className="w-5 h-5 text-brand-red" data-id="element-301" />
                    </div>
                    <div data-id="element-302">
                      <p className="font-bold text-brand-dark" data-id="element-303">Adres</p>
                      <p className="text-brand-gray" data-id="element-304">
                        Capsin International
                        <br data-id="element-305" />
                        Nederland
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div data-id="element-306">
                <h3 className="text-2xl font-serif font-bold text-brand-dark mb-4" data-id="element-307">
                  Retail/ Horeca/ Groothandel
                </h3>
                <p className="text-brand-gray mb-4" data-id="element-308">
                  Wij slaan graag de handen ineen om de samenwerking met u aan
                  te gaan. Capsin verbreedt graag uw assortiment met onze
                  producten.
                </p>
                <p className="text-brand-dark font-medium" data-id="element-309">
                  Neem snel contact met ons op!
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="w-full lg:w-2/3" data-id="element-310">
              <div className="bg-brand-cream rounded-3xl p-8 md:p-12" data-id="element-311">
                <h2 className="text-3xl font-serif font-bold text-brand-dark mb-2" data-id="element-312">
                  Contactformulier
                </h2>
                <p className="text-brand-gray mb-8" data-id="element-313">
                  U kunt rechtstreeks naar ons mailen via bovenstaande gegevens
                  of u kunt het onderstaande contactformulier gebruiken. Wij
                  nemen dan zo spoedig mogelijk contact met u op.
                </p>

                <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-314">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-315">
                    <div data-id="element-316">
                      <label className="block text-sm font-bold text-brand-dark mb-2" data-id="element-317">
                        Voornaam <span className="text-brand-red" data-id="element-318">*</span>
                      </label>
                      <input type="text" className="w-full bg-white border border-gray-200 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all" required data-id="element-319" />
                    </div>
                    <div data-id="element-320">
                      <label className="block text-sm font-bold text-brand-dark mb-2" data-id="element-321">
                        Achternaam
                      </label>
                      <input type="text" className="w-full bg-white border border-gray-200 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all" data-id="element-322" />
                    </div>
                  </div>

                  <div data-id="element-323">
                    <label className="block text-sm font-bold text-brand-dark mb-2" data-id="element-324">
                      E-mail <span className="text-brand-red" data-id="element-325">*</span>
                    </label>
                    <input type="email" className="w-full bg-white border border-gray-200 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all" required data-id="element-326" />
                  </div>

                  <div data-id="element-327">
                    <label className="block text-sm font-bold text-brand-dark mb-2" data-id="element-328">
                      Reactie of bericht{' '}
                      <span className="text-brand-red" data-id="element-329">*</span>
                    </label>
                    <textarea rows={6} className="w-full bg-white border border-gray-200 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red transition-all resize-none" required data-id="element-330"></textarea>
                  </div>

                  <button type="submit" className="bg-brand-red text-white px-8 py-4 rounded-full font-medium hover:bg-brand-darkRed hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 flex items-center gap-2" data-id="element-331">
                    <Send size={18} data-id="element-332" />
                    Verzend bericht
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}